import React from "react";
import { useState } from "react";
import Box from "@mui/material/Box";
import strings from "../../config/localization";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import { useNavigate, useParams } from "react-router-dom";
import { useGetPermissionsOfRoleQuery } from "../../services/appln";
import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import CommonPagination from "../../components/CustomPagination/CommonPagination";
import CommonTable from "../../components/CustomTable/CommonTable";
import AddButton from "../../components/Buttons/AddButton";
import PermissionRemove from "./PermissionRemove";
import { getRowsPerPage } from "../constants";

export default function RolePermissionList() {
  const { roleId } = useParams();
  const navigate = useNavigate();

  const [count, setCount] = useState(1);
  const [rowPerPage, setRowPerPage] = useState(getRowsPerPage());

  const getParams = {
    roleId: roleId,
    page: count,
    limit: rowPerPage,
    search: "",
  };

  const { data, error, isLoading, isFetching } =
    useGetPermissionsOfRoleQuery(getParams);

  const columns = [
    {
      field: "name",
      headerName: strings.name,
      width: 300,
    },
    {
      field: "delete",
      headerName: "",
      width: 150,
      renderCell: (params: any) => (
        <PermissionRemove roleId={roleId} permissionId={params.id} />
      ),
    },
  ];

  const handleChangePage = (event: any, value: any) => {
    setCount(value);
  };

  const handleChangeCount = (e: any) => {
    setRowPerPage(e.target.value);
  };

  return (
    <div>
      <Box sx={{ width: "100%" }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {isLoading || isFetching ? (
              <Backdrop
                sx={{
                  color: "#fff",
                  zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open
              >
                <CircularProgress color="inherit" />
              </Backdrop>
            ) : null}
          </Grid>
          {error ? (
            <Grid item xs={12}>
              <Alert severity="error">
                <AlertTitle>{strings.error}</AlertTitle>
                {strings.failedToLoadPermissions}
              </Alert>
            </Grid>
          ) : null}
          <Grid item xs={12}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom component="div">
                  {" "}
                  {strings.permissions}{" "}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <AddButton
                  onClickHandler={() => {
                    navigate(`../selectPermissions/${roleId}`);
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <div>
              <CommonTable
                rows={data?.data ? data?.data : []}
                columns={columns}
                checkboxSelection={false}
              />
              <CommonPagination
                count={Math.ceil(data?.totalCount / rowPerPage)}
                page={count}
                handleChangePage={handleChangePage}
                rowPerPage={rowPerPage}
                handleChangeCount={handleChangeCount}
              />
            </div>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
